module.exports = __webpack_public_path__ + "static/media/props.41feb745.png";